import { fetch } from "../../../appContainer";
import {
  GET_DASHBOARD_CATEGORY_METRICS_FAIL,
  GET_DASHBOARD_CATEGORY_METRICS_IN_PROGRESS,
  GET_DASHBOARD_CATEGORY_METRICS_SUCCESS,
} from "../constants";

const categoryFetchers = {
  interventions: (api, interventionsSince, success, failure) =>
    api.getDashboardInterventionsMetrics(interventionsSince, success, failure),
  containers: (api, _interventionsSince, success, failure) =>
    api.getDashboardContainersMetrics(success, failure),
  leak_detectors: (api, _interventionsSince, success, failure) =>
    api.getDashboardLeakDetectorsMetrics(success, failure),
  pressure_gauges: (api, _interventionsSince, success, failure) =>
    api.getDashboardPressureGaugesMetrics(success, failure),
  scales: (api, _interventionsSince, success, failure) =>
    api.getDashboardScalesMetrics(success, failure),
  thermometers: (api, _interventionsSince, success, failure) =>
    api.getDashboardThermometersMetrics(success, failure),
  installations_basic: (api, _interventionsSince, success, failure) =>
    api.getDashboardInstallationsBasicMetrics(success, failure),
  installations_after_repair: (api, _interventionsSince, success, failure) =>
    api.getDashboardInstallationsAfterRepairMetrics(success, failure),
  installations_periodicity: (api, _interventionsSince, success, failure) =>
    api.getDashboardInstallationsPeriodicityMetrics(success, failure),
  trackdechets: (api, _interventionsSince, success, failure) =>
    api.getDashboardTrackdechetsMetrics(success, failure),
  service_providers: (api, _interventionsSince, success, failure) =>
    api.getDashboardServiceProvidersMetrics(success, failure),
};

export function getDashboardCategoryMetrics(category, interventionsSince) {
  return (dispatch) => {
    const fetcher = categoryFetchers[category];
    if (!fetcher) {
      return;
    }

    dispatch({
      type: GET_DASHBOARD_CATEGORY_METRICS_IN_PROGRESS,
      payload: { category },
    });

    const api = fetch("api");
    fetcher(
      api,
      interventionsSince,
      (metrics) => {
        dispatch({
          type: GET_DASHBOARD_CATEGORY_METRICS_SUCCESS,
          payload: { category, metrics },
        });
      },
      () =>
        dispatch({
          type: GET_DASHBOARD_CATEGORY_METRICS_FAIL,
          payload: { category },
        }),
    );
  };
}
